import { render, staticRenderFns } from "./UserInviteList.vue?vue&type=template&id=130e1040"
import script from "./UserInviteList.vue?vue&type=script&lang=js"
export * from "./UserInviteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports